<div class="column">
  <h2 mat-dialog-title>{{"login.reset_password.title" | transloco}}</h2>

  <mat-dialog-content class="column-gap">
    <div class="text">{{"login.reset_password.info" | transloco}}</div>

    <mat-form-field hideRequiredMarker="true">
      <mat-label>{{ "form.label.email" | transloco }}</mat-label>
      <input [formControl]="emailFormControl" matInput />
    </mat-form-field>

    @if (errorMessage) {
      <mat-error>{{ errorMessage }}</mat-error>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="close()" mat-button>{{"button.cancel" | transloco}}</button>
    <button (click)="resetPassword()" mat-flat-button>{{"login.reset_password.button" | transloco}}</button>
  </mat-dialog-actions>
</div>
